const Util = {
  dist (pos1, pos2) {
    return Math.sqrt(
      Math.pow(pos1[0] - pos2[0], 2) + Math.pow(pos1[1] - pos2[1], 2)
    );
  },

  norm (vec) {
    return Util.dist([0, 0], vec);
  },

  randomVec (length) {
    var deg = 2 * Math.PI * Math.random();
    return Util.scale([Math.sin(deg), Math.cos(deg)], length);
  },

  scale (vec, m) {
    return [vec[0] * m, vec[1] * m];
  },

  dir (vec) {
    var norm = Util.norm(vec);
    return Util.scale(vec, 1 / norm);
  }
};

module.exports = Util;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/util.js
 ** module id = 4
 ** module chunks = 0
 **/